import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { ConnectionAuthKind } from 'shell-models-lib';
import { DataSourceOptionKind } from '@powerquery/mashup-editor-client';
import { GlobalVariables } from 'app/services/globals';

const serverSettingControls: ControlMetadata[] = [{
    type: 'radio-switch',
    bind: 'logonType',
    label: stringResources.SapTable_LogonType,
    isLabelVertical: true,
    nested: 1,
    options: [
        {
            label: stringResources.SapTable_LogonType_ApplicationServer,
            value: 'applicationServer'
        },
        {
            label: stringResources.GroupLabel,
            value: 'group'
        }
    ],
    defaultValue: 'applicationServer',
    cases: [
        {
            caseValue: 'applicationServer',
            children: [
                {
                    type: 'textbox',
                    bind: 'server',
                    label: stringResources.ModelName_ServerName,
                    required: true,
                    validators: [
                        { type: 'required', errorMessage: '' }
                    ],
                    isLabelVertical: true
                },
                {
                    type: 'textbox',
                    bind: 'systemNumber',
                    label: stringResources.ModelName_SystemNumber,
                    required: true,
                    validators: [
                        { type: 'required', errorMessage: '' }
                    ],
                    isLabelVertical: true
                }
            ]
        },
        {
            caseValue: 'group',
            children: [
                {
                    type: 'textbox',
                    bind: 'messageServer',
                    label: stringResources.ModelName_MessageServer,
                    required: true,
                    validators: [
                        { type: 'required', errorMessage: '' }
                    ],
                    isLabelVertical: true
                },
                {
                    type: 'textbox',
                    bind: 'messageServerService',
                    label: stringResources.ModelName_MessageServerService,
                    isLabelVertical: true
                },
                {
                    type: 'textbox',
                    bind: 'systemId',
                    label: stringResources.ModelName_SystemId,
                    isLabelVertical: true
                },
                {
                    type: 'textbox',
                    bind: 'logonGroup',
                    label: stringResources.ModelName_LogonGroup,
                    isLabelVertical: true
                }
            ]
        }
    ]
}];

export const sapOpenHubMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.sapOpenHub.linkedServiceType,
    displayName: stringResources.SapOpenHub_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-SapBW'
    },
    supportDatasetV2: true,
    isOnPremises: true,
    isFirstClass: true,
    supportedInTrident: GlobalVariables.enableOPDG,
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'SAPBWOpenHubMessageServer',
    },
    supportedAuthKindsInTrident: [ConnectionAuthKind.Basic],
    supportOPDG: GlobalVariables.enableOPDG,
    supportCopyJobSource: GlobalVariables.enableOPDG,
    supportedJobModesAsSource: GlobalVariables.copyJobIncrementalCopyPhase2 ? undefined : ['Batch'],
    supportAutoFillCopilotInput: GlobalVariables.enableOPDG,
    isKnownInPipelineContext: GlobalVariables.enableOPDG,
    copySourceTypes: [adfModelTypeMap.sapOpenHub.copySourceType],
    copySinkTypes: [],
    tableNameAlias: 'openHubDestinationName',
    onetimeQueryTemplate: '',
    timedQueryTemplate: '',
    category: ['Database'],
    controls: [
        ...serverSettingControls,
        {
            type: 'textbox',
            bind: 'clientId',
            label: stringResources.ModelName_ClientId,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'language',
            label: stringResources.Language,
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'userName',
            label: stringResources.ModelName_UserName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'password',
            label: stringResources.ModelName_Password,
            enableAKVParameterization: true,
            child: {
                type: 'password',
                label: stringResources.ModelName_Password,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.SapOpenHub_DisplayText),
                stringResources.ModelName_Password)
        }
    ]
};
